import { Component, OnInit, Inject, ChangeDetectionStrategy } from "@angular/core";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ToastService } from "src/app/services/toast.service";
import { OrganizationLevelPermissionsService } from "src/app/services/orgLevelPermissions.service";
import { OrganizationLevelPermissions } from "src/app/models/organizationLevelPermissions";

export interface EditOrgLevelPermissionsDialogData {
    orgId: string;
}

@Component({
  standalone: false,
    selector: "app-edit-org-level-permissions-dialog",
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: "editOrgLevelPermissionsDialog.component.html",
})
export class EditOrgLevelPermissionsDialogComponent implements OnInit {
    isFormLoading = false;
    isLoading = false;
    orgLevelPermissions: OrganizationLevelPermissions;

    constructor(
        public dialogRef: MatDialogRef<EditOrgLevelPermissionsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: EditOrgLevelPermissionsDialogData,
        private orgLevelPermissionsService: OrganizationLevelPermissionsService,
        private toastService: ToastService,
    ) {
        this.orgLevelPermissions = new OrganizationLevelPermissions();
    }

    ngOnInit() {
        this.isFormLoading = true;
        //TODO: after getting the design
        // this.orgLevelPermissionsService.getOrganizationLevelPermissions(this.data.orgId, this.data.tenantId)
        //     .subscribe(
        //         orgLevelPermissions => {
        //             this.orgLevelPermissions = orgLevelPermissions;
        //             this.isFormLoading = false;
        //         },
        //         error => {
        //             this.toastService.displayErrorMessage('Error loading organization level permissions.');
        //             this.isFormLoading = false;
        //         });
    }

    save() {
        this.isLoading = true;
        this.orgLevelPermissionsService
            .create(this.orgLevelPermissions)
            .subscribe(
                (response) => {
                    this.toastService.showSuccess(
                        "Organization level permissions saved successfully",
                        true,
                    );
                    this.isLoading = false;
                    this.dialogRef.close();
                },
                (error) => {
                    this.toastService.showError(error);
                    this.isLoading = false;
                },
            );
    }
}
